import React from 'react';
import { newUiColorTokens } from '../../../frontend/theme/themeTokens';

interface DefaultWorkflowIconProps {
  color?: string;
  height?: number | string;
  width?: number | string;
  opacity?: number;
  style?: React.CSSProperties;
  className?: string;
  'aria-label'?: string;
}

const DefaultWorkflowIcon: React.FC<DefaultWorkflowIconProps> = ({
  color = newUiColorTokens.prime.blue,
  height = 24,
  width = 24,
  opacity = 1,
  style,
  className,
  'aria-label': ariaLabel,
}) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    height={height}
    width={width}
    viewBox="0 0 640 640"
    style={{ opacity, ...style }}
    className={className}
    aria-label={ariaLabel}
    role={ariaLabel ? 'img' : 'presentation'}
  >
    {/* Generic workflow/process icon - represents connected steps in a workflow */}
    <path
      fill={color}
      d="M176 96C176 78.3 190.3 64 208 64L432 64C449.7 64 464 78.3 464 96L464 160C464 177.7
         449.7 192 432 192L208 192C190.3 192 176 177.7 176 160L176 96zM224 112L224 144L416
         144L416 112L224 112zM296 192L296 256L176 256C158.3 256 144 270.3 144 288L144
         352C144 369.7 158.3 384 176 384L296 384L296 448L64 448C46.3 448 32 462.3 32 480L32
         544C32 561.7 46.3 576 64 576L288 576C305.7 576 320 561.7 320 544L320 480C320 462.3
         305.7 448 288 448L344 448L344 384L464 384C481.7 384 496 369.7 496 352L496 288C496
         270.3 481.7 256 464 256L344 256L344 192L296 192zM192 304L448 304L448 336L192
         336L192 304zM80 496L272 496L272 528L80 528L80 496zM352 448C334.3 448 320 462.3 320
         480L320 544C320 561.7 334.3 576 352 576L576 576C593.7 576 608 561.7 608 544L608
         480C608 462.3 593.7 448 576 448L352 448zM368 496L560 496L560 528L368 528L368 496z"
    />
  </svg>
);

export default DefaultWorkflowIcon;
